import env from '../config/env';

export interface AuthConfig {
  authority: string;
  clientId: string;
  redirectUri: string;
  scope: string;
}

/**
 * Exposes the Authentik OIDC configuration (BHP-1040).
 *
 * Environment values are validated centrally in `src/config/env.ts`
 * (fail-fast on missing required vars), so this service only maps them
 * onto the AuthConfig shape consumed by the OIDC AuthProvider.
 */
class AuthService {
  private readonly authConfig: AuthConfig;

  constructor() {
    this.authConfig = {
      authority: env.auth.authority,
      clientId: env.auth.clientId,
      redirectUri: env.auth.redirectUri,
      scope: env.auth.scope
    };
  }

  public getAuthConfig(): AuthConfig {
    return this.authConfig;
  }
}

export default AuthService;
